import React, { FunctionComponent } from 'react';
import { Trans } from 'react-i18next';
import { teamIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { Track } from '@justgiving/react-tracking';
import { useInView } from 'react-intersection-observer';
import './JoinTeam.scss';
import PATHS from '../../constants/paths';
import { useNotNullableContext } from '../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../context/PageMetaContext';

import useBasePageQuery from '../../hooks/useBasePageQuery';

const JoinTeam: FunctionComponent = () => {
  const basePageData = useBasePageQuery();
  const [ref, inView] = useInView();
  const { isInvite } = useNotNullableContext(PageMetaContext);

  if (!basePageData.data?.page) {
    return null;
  }

  const { legacyId, owner } = basePageData.data.page;

  if (isInvite) {
    return (
      <div className="jg-pages-joinTeam__placeholder">
        <div ref={ref} className="jg-display-n@xs jg-display-b@xl" />
        <aside
          data-qa="join-team"
          className={`jg-pages-joinTeam${
            !inView ? ' jg-pages-joinTeam--stuck' : ''
          }`}
        >
          <div className="container jg-space-phmd jg-space-phml@xl jg-space-pvmd jg-space-pvsm@xl jg-pages-joinTeam__container">
            <Svg markup={teamIcon} className="jg-pages-joinTeam__icon" />
            <div className="jg-pages-joinTeam__content">
              <Trans i18nKey="team.joinMessage">
                <strong>{{ name: owner!.name }}</strong> invited you to join the
                team
              </Trans>
            </div>
            <div className="jg-pages-joinTeam__cta">
              <Track>
                {track => (
                  <a
                    href={`${PATHS.JOIN_URL}${legacyId}`}
                    className="jg-btn jg-btn--themed"
                    onClick={() =>
                      track({
                        action_name: 'link click',
                        subtype: 'button',
                        event_value: 'accept',
                        page_section: 'join team',
                      })
                    }
                  >
                    <Trans i18nKey="team.joinCta">
                      Accept
                      <span className="jg-sr-only">
                        {' '}
                        the invitation to join the team
                      </span>
                    </Trans>
                  </a>
                )}
              </Track>
            </div>
          </div>
        </aside>
      </div>
    );
  }
  return null;
};

export default JoinTeam;
